import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ShieldIcon } from '../../../assets/images/icons/compare_shield.svg';
import styles from './Rescue.module.scss';

interface RescueOfferBoxProps {
  /** Formatted activation fee. Omitted when the selected plan does not expose one. */
  activationFee?: string;
  /** Formatted discount amount for the badge. Omitted outside the promo-banner countries. */
  badgeAmount?: string | null;
  /** Lets the pdp fire a viewed event the first time the box scrolls in. */
  containerRef?: React.RefObject<HTMLDivElement>;
}

/**
 * States what the adoption actually covers. The badge carries the discount amount in neutral gray
 * (yellow stays reserved for the CTA), and it drops out entirely rather than guessing when the
 * amount is not displayable in the shopper's country. This block exists because "6 months free"
 * was previously only legible by reading a struck-through price.
 */
export default function RescueOfferBox({ activationFee, badgeAmount, containerRef }: RescueOfferBoxProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.offerBox} ref={containerRef}>
      <div className={styles.offerTopRow}>
        <div className={styles.offerTitle}>{t('rescue_offer_title')}</div>
        {badgeAmount && (
          <div className={styles.offerBadge}>
            <ShieldIcon aria-hidden />
            {t('rescue_offer_badge', { amount: badgeAmount })}
          </div>
        )}
      </div>
      <div className={styles.offerBody}>
        {activationFee ? t('rescue_offer_body_with_fee', { activationFee }) : t('rescue_offer_body')}
      </div>
    </div>
  );
}
